import moment from "moment";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { IoArrowBackSharp } from "react-icons/io5";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import swal from "sweetalert";
import {
  applyClassToCharacters,
  convertUTCToLocalTime,
  getStringFromJSX,
  isUrdu,
  LoadingSpinner,
} from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import GenericSwitch from "../../shared/GenericSwitch";
import { addMember } from "../ApiMember";
import { ApiMemberTypeRequest } from "./ApiMemberTypeRequest";

const colors = {
  primary: "#1d9fad", // New primary color (teal-cyan)
  primaryLight: "#4dbbc8", // Lighter variant of new primary
  primaryDark: "#147d89", // Darker variant of new primary
  secondary: "#7DB9A2", // Dusty seafoam green
  accent: "#94C4CC", // Pale sky blue
  background: "#F8FBFB", // Very light blue-white
  text: "#2D3747", // Dark blue-gray
  textLight: "#6B7C8C", // Soft blue-gray
  border: "#D8E1E6", // Light blue-gray
  success: "#5AB885", // Muted green
  warning: "#E4B363", // Soft gold
  error: "#E67C73", // Dusty coral
  progressLine: "#D1DDE5", // Very light blue-gray
  stepInactive: "#E0E8EC", // Pale blue for inactive steps
};

const MemberTypeRequestMultazim = ({ history, memberTypeData }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [values, setValues] = useState({});

  useEffect(() => {
    setLoading(true);
    setButtonDisable(true);
    ApiMemberTypeRequest()
      .GetMubtadiToMultazimFormData({ memberId: memberTypeData.memberId })
      .then((res) => {
        setValues(res.data);
        setLoading(false);
        setButtonDisable(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setButtonDisable(false);
      });
    // eslint-disable-next-line
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setButtonDisable(true);
    memberTypeData.memberMultazimFormModel = values;
    addMember()
      .addMemberType(memberTypeData, false)
      .then((res) => {
        if (res.data === "CanNotChange") {
          swal({
            title: t("member__member_type_not_change_able"),
            icon: "warning",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            buttons: "OK",
          });
        } else if (res.data === "Request Already Generated") {
          swal({
            title: t(res.data),
            icon: "error",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            buttons: "OK",
          });
        } else {
          swal({
            title: t(res.data),
            icon: "success",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            buttons: "OK",
          });
          history.goBack();
        }
        setLoading(false);
        setButtonDisable(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setButtonDisable(false);
      });
  };
  return (
    <Card className="mb-4">
      <CardHeader className="bg-white d-flex justify-content-between align-items-center py-3">
        <h4 className="mb-0" style={{ fontSize: "1.25rem", fontWeight: 500 }}>
          {applyClassToCharacters(
            getStringFromJSX(
              <GetLanguageString
                props="member_member_type_request_title"
                value={memberTypeData.memberType.label}
              />
            ),
            "ur"
          )}
        </h4>
        <Button
          color="default"
          className="d-flex align-items-center"
          onClick={() => history.goBack()}
        >
          <IoArrowBackSharp className="me-2" color="#18A689" size={15} />
          {<GetLanguageString props="courses_participants_back" />}
        </Button>
      </CardHeader>
      <CardBody>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            {" "}
            <Row>
              <Col md="6">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",

                    border: "none",
                  }}
                >
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString
                        props={"member_member_type_request_muqami_tanzeem"}
                      />
                    </CardTitle>
                    <CardText
                      className={isUrdu(values.tanzeemName) ? "ur" : ""}
                      style={{
                        fontSize: "18px",
                        color: colors.text,
                        fontWeight: "600",
                        wordBreak: "break-word",
                      }}
                    >
                      {values.tanzeemName || "—"}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",
                    border: "none",
                  }}
                >
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString props={"member_report_member_halqa"} />
                    </CardTitle>
                    <CardText
                      className={isUrdu(values.halqaName) ? "ur" : ""}
                      style={{
                        fontSize: "18px",
                        color: colors.text,
                        fontWeight: "600",
                        wordBreak: "break-word",
                      }}
                    >
                      {values.halqaName || "—"}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <br></br>
            <Row>
              {[
                { key: "memberFullName", label: "common_name", isUrdu: true },
                {
                  key: "memberFatherName",
                  label: "member_father_name",
                  isUrdu: true,
                },
                { key: "memberAge", label: "member_age", isUrdu: false },
                {
                  key: "memberRegistrationNumber",
                  label: "member_report_member_registrationNumber",
                  isUrdu: true,
                },
              ].map((field) => (
                <Col md="3">
                  <Card
                    className="mb-3"
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                      height: "100%",
                      border: "none",
                    }}
                  >
                    <CardBody>
                      <CardTitle
                        tag="h5"
                        style={{
                          color: colors.primary,
                          fontWeight: "600",
                          fontSize: "16px",
                          marginBottom: "12px",
                        }}
                      >
                        <GetLanguageString props={field.label} />
                      </CardTitle>
                      <CardText
                        className={
                          field.isUrdu && isUrdu(values[field.key]) ? "ur" : ""
                        }
                        style={{
                          fontSize: "16px",
                          color: colors.text,
                          wordBreak: "break-word",
                        }}
                      >
                        {values[field.key] || "—"}
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <br></br>
            <Row>
              {[
                {
                  key: "memberPledgeDate",
                  label: "member_member_detail_pledges_date",
                  isUrdu: false,
                },
                {
                  key: "mubtadiCourseDate",
                  label: "member_member_type_request_mubtadi_course_date",
                  isUrdu: false,
                },
                {
                  key: "mubtadiCourseLocation",
                  label: "member_member_type_request_mubtadi_course_location",
                  isUrdu: true,
                },
                {
                  key: "isMubtadiNisaabComplete",
                  label: "book_update_book2",
                  isUrdu: false,
                },
              ].map((field) => (
                <Col md="3">
                  <Card
                    className="mb-3"
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                      height: "100%",
                      border: "none",
                    }}
                  >
                    <CardBody>
                      <CardTitle
                        tag="h5"
                        style={{
                          color: colors.primary,
                          fontWeight: "600",
                          fontSize: "16px",
                          marginBottom: "12px",
                        }}
                      >
                        <GetLanguageString props={field.label} />
                      </CardTitle>
                      <CardText
                        className={
                          field.isUrdu && isUrdu(values[field.key]) ? "ur" : ""
                        }
                        style={{
                          fontSize: "16px",
                          wordBreak: "break-word",
                          color: field.key.includes("Nisaab")
                            ? values[field.key]
                              ? "green"
                              : "red"
                            : colors.text,
                        }}
                      >
                        {field.key.includes("date")
                          ? values[field.key]
                            ? moment(
                                convertUTCToLocalTime(values[field.key])
                              ).format("DD/MM/yyyy")
                            : ""
                          : field.key.includes("Nisaab")
                          ? values[field.key]
                            ? t("courses_status_completed")
                            : t("courses_status_incompleted")
                          : values[field.key] || "—"}
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <br></br>
            <hr></hr>
            <br></br>
            <Row>
              {" "}
              <Col md="6">
                <FormGroup>
                  <Row>
                    <Col md="10">
                      <Label
                        className="col-form-label ur"
                        style={{ fontSize: 15 }}
                      >
                        کیا اجتماعات وغیرہ میں بروقت اور کل وقتی شرکت میں
                        باقاعدگی ہے ؟
                      </Label>
                    </Col>
                    <Col md="2" style={{ marginTop: 5 }}>
                      <GenericSwitch
                        label="isRegularInIjtimaat"
                        value={values.isRegularInIjtimaat}
                        setValues={setValues}
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Row>
                    <Col md="10">
                      <Label
                        className="col-form-label ur"
                        style={{ fontSize: 15 }}
                      >
                        کیا دیگر پہلوؤں(رخصت / اجازت / مشاورت / تنقید وغیرہ ) کے
                        حوالے سے نظم کی پابندی کرتے ہیں ؟
                      </Label>
                    </Col>
                    <Col md="2" style={{ marginTop: 5 }}>
                      <GenericSwitch
                        label="isFollowTanzeemLaws"
                        value={values.isFollowTanzeemLaws}
                        setValues={setValues}
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              {" "}
              <Col md="6">
                <FormGroup>
                  <Row>
                    <Col md="10">
                      <Label
                        className="col-form-label ur"
                        style={{ fontSize: 15 }}
                      >
                        کیا انفاق کی سعادت باقاعدگی سے حاصل کرتے ہیں ؟
                      </Label>
                    </Col>
                    <Col md="2" style={{ marginTop: 5 }}>
                      <GenericSwitch
                        label="isGivingFundRegularly"
                        value={values.isGivingFundRegularly}
                        setValues={setValues}
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label className="col-form-label ur" style={{ fontSize: 15 }}>
                    وضع قطع (داڑھی و لباس ) میں سنت پر عمل کرنے کا اہتمام کس قدر
                    ہے ؟
                  </Label>
                  <Input
                    type="text"
                    name="conditionOfMaintainingPhysicallyAccordingToSunnah"
                    className={
                      isUrdu(values.conditionOfMaintainingPhysicallyAccordingToSunnah)
                        ? "ur "
                        : ""
                    }
                    value={values.conditionOfMaintainingPhysicallyAccordingToSunnah}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="col-form-label ur" style={{ fontSize: 15 }}>
                    غیر مخلوط معاشرت و پردہ کا اہتمام کس قدر ہے ؟
                  </Label>
                  <Input
                    type="text"
                    name="conditionOfAvoidAttendingMehfilGhairMehram"
                    className={
                      isUrdu(values.conditionOfAvoidAttendingMehfilGhairMehram)
                        ? "ur "
                        : ""
                    }
                    value={values.conditionOfAvoidAttendingMehfilGhairMehram}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <FormGroup>
                  <Label className="col-form-label ur" style={{ fontSize: 15 }}>
                    فرض نمازوں کی باجماعت ادائیگی میں باقاعدگی کی کیفیت ؟
                    (بلخصوص فجر و عشاء)
                  </Label>
                  <Input
                    type="text"
                    name="conditionOfPrayingObligatoryPrayersInMasjid"
                    className={
                      isUrdu(values.conditionOfPrayingObligatoryPrayersInMasjid)
                        ? "ur "
                        : ""
                    }
                    value={values.conditionOfPrayingObligatoryPrayersInMasjid}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label className="col-form-label ur" style={{ fontSize: 15 }}>
                    ذریعہ معاش کیا ہے ؟
                  </Label>

                  <Input
                    type="text"
                    name="sourceOfIncome"
                    className={isUrdu(values.sourceOfIncome) ? "ur " : ""}
                    value={
                      values.sourceOfIncome
                        ? getStringFromJSX(
                            applyClassToCharacters(values.sourceOfIncome, "ur")
                          )
                        : ""
                    }
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label className="col-form-label ur" style={{ fontSize: 15 }}>
                    مالی لین دین کے معملات کیسے ہیں؟{" "}
                  </Label>
                  <Input
                    type="text"
                    className="ur"
                    name="financialStatus"
                    value={values.financialStatus ? values.financialStatus : ""}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              {" "}
              <Col md="12">
                <FormGroup>
                  <Label className="col-form-label ur" style={{ fontSize: 15 }}>
                    دیگر قابل ذکر امور
                  </Label>
                  <Input
                    type="text"
                    className="ur"
                    name="otherInformation"
                    value={
                      values.otherInformation ? values.otherInformation : ""
                    }
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <hr></hr>
            <Row>
              <Col md="6">
                <Label className="col-form-label ur" style={{ fontSize: 15 }}>
                  نام نقیب اسره{" "}
                </Label>
                <Input
                  type="text"
                  disabled
                  name="naqeebName"
                  className={isUrdu(values.naqeebName) ? "ur" : " "}
                  value={values.naqeebName}
                />
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="col-form-label" style={{ fontSize: 15 }}>
                    <GetLanguageString props={"dashboard_event_page_date"} />
                  </Label>
                  <DatePicker
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="dd/mm/yyyy"
                    className="form-control"
                    selected={new Date()}
                    dateFormat="dd/MM/yyyy"
                    disabled
                  />
                </FormGroup>
              </Col>
            </Row>
            <hr></hr>
            <Row className="m-0">
              <div>
                <h3>
                  {" "}
                  <GetLanguageString props={"common_instructions"} /> :
                </h3>
                <ul dir="rtl" style={{ listStyleType: "none" }}>
                  <li>
                    <h3
                      className="ur"
                      style={{ fontWeight: "lighter", lineHeight: 1.5 }}
                    >
                      <span className="font-bold">(i)</span> ہر کالم کو مکمل پر
                      کیا جائے.
                    </h3>
                  </li>
                  <li>
                    <h3
                      className="ur"
                      style={{ fontWeight: "lighter", lineHeight: 1.5 }}
                    >
                      <span className="font-bold">(ii)</span> ہر سوال کا جواب
                      واضح ہو صرف ✓ یا ✕ پر اکتفا نہ کیا جائے .
                    </h3>
                  </li>
                  <li>
                    <h3
                      className="ur"
                      style={{ fontWeight: "lighter", lineHeight: 1.5 }}
                    >
                      <span className="font-bold">(ii)</span> متعلقہ نقیب خود یہ
                      فارم پر کرے ، رفیق سے پر نہ کروایا جائے.
                    </h3>
                  </li>
                </ul>
              </div>
            </Row>
            <br></br>
            <Row>
              <Col md="8"></Col>
              <Col md="4">
                <ButtonGroup className={GetCustomStyles().btn_group_style}>
                  <Button color="white" onClick={() => history.goBack()}>
                    {<GetLanguageString props="common_cancel" />}
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    color="primary"
                    disabled={buttonDisable}
                    className="m-l-sm"
                    type="submit"
                  >
                    {<GetLanguageString props="common_save_changes" />}
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </CardBody>
    </Card>
  );
};

export default withRouter(MemberTypeRequestMultazim);
